import ReactGA from 'react-ga4';

export default function sendMenuClickEvent(menuItem: string) {
   ReactGA.event({
      category: 'click',
      action: 'Menu Click - ' + menuItem
   });
}